export const ADD_PET_POPUP_ID = 'add-pet';
export const SUBSCRIPTION_POPUP_ID = 'subscription-popup';
